import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      zIndex: theme.zIndex.faceModal,
    },
    buttonClose: {
      position: "absolute",
      right: 0,
      top: 0,
      marginRight: 2,
      marginTop: 2,
      transform: "translate(50%, -50%)",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      padding: 4,
      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(36),
      },
    },
    paper: {
      overflowY: "initial",
      padding: [20, 24],
      width: 271,
      borderRadius: 10,
      boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
      position: "relative",
      [theme.breakpoints.up("mobile")]: {
        width: 406,
        padding: [30, 40],
        borderRadius: 20,
      },
    },
    title: {
      textAlign: "center",
      color: theme.palette.cloudBirst,
      letterSpacing: ".5px",
      margin: "0 auto 10px",
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(17),
      lineHeight: theme.typography.pxToRem(25),
      padding: 0,
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(24),
        lineHeight: theme.typography.pxToRem(37),
        marginBottom: 20,
      },
    },
    listItem: {
      padding: [10, 8],
      "&:hover": {
        backgroundColor: theme.palette.common.white,
        "& $listItemText": {
          color: theme.palette.secondary.main,
        },
      },
      [theme.breakpoints.up("mobile")]: {
        padding: [20, 12],
      },
    },
    listItemText: {
      lineHeight: theme.typography.pxToRem(40),
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.cloudBirst,
      margin: 0,
      [theme.breakpoints.up("mobile")]: {
        lineHeight: theme.typography.pxToRem(50),
        fontSize: theme.typography.pxToRem(22),
      },
    },
    listItemAvatar: {
      width: 56,
      marginRight: 8,
      textAlign: "center",
      [theme.breakpoints.up("mobile")]: {
        width: 84,
      },
    },
    listItemIcon: {
      width: 29,
      [theme.breakpoints.up("mobile")]: {
        width: 45,
      },
    },
    listItemIconFacebook: {
      width: 14,
      [theme.breakpoints.up("mobile")]: {
        width: 20,
      },
    },
    lastPhoto: {
      margin: "auto",
      overflow: "hidden",
      height: 42,
      width: 42,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.up("mobile")]: {
        height: 63,
      },
    },
    lastPhotoImage: {
      border: "2px solid",
      borderColor: theme.palette.cloudBurst,
      display: "block",
      width: 42,
      [theme.breakpoints.up("mobile")]: {
        minHeight: "auto",
        width: 63,
      },
    },
    inputFile: {
      display: "none",
    },
  }),
  { name: "FaceUploadModal" },
);
